import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { RoutingPath } from "src/app/configs/routing-path";
import { InformationFormatting } from "src/app/core/helpers/information-formatting/information-formatting";
import { IAffiliatesProcess } from "src/app/core/models/affiliation/iaffiliate-process";
import { IContribuyente } from "src/app/core/models/business-information/ibusiness-information";
import { IUser } from "src/app/core/models/user/user";
import { AffiliationService } from "src/app/core/services/affiliation/affiliation.service";
import { CompanyService } from "src/app/core/services/company/company.service";
import { LocalStorageService } from "src/app/core/services/local-storage/local-storage.service";

@Component({
  selector: "app-affiliates-process",
  templateUrl: "./affiliates-process.component.html",
  styleUrls: ["./affiliates-process.component.scss"],
})
export class AffiliatesProcessComponent implements OnInit {
  @Input() titleSite: string;
  @Input() userloggedin: IUser;
  affiliateProcess: Array<IAffiliatesProcess>;

  companyData: IContribuyente;
  loadingTop = false;
  loadingDetail: boolean[] = [];
  constructor(
    private affiliationService: AffiliationService,
    private _ROUTER: Router,
    private _STORAGE: LocalStorageService,
    private companyService: CompanyService
  ) {}

  ngOnInit() {
    this.fillAffiliateProcess();
  }

  fillAffiliateProcess() {
    this.affiliateProcess = new Array<IAffiliatesProcess>();
    this.loadingTop = true;
    this.affiliationService
      .getTopAffiliations(this.userloggedin.docNumberCompany, "3")
      .subscribe((res) => {
        this.affiliateProcess = res;
        this.loadingTop = false;
      });
  }

  downloadElement(process: IAffiliatesProcess, index: number) {
    this.loadingDetail[index] = true;
    this.companyData = this._STORAGE.getItemJSON(
      environment.LOCAL_STORAGE.BUSINESS_INFORMATION
    );
    if (this.companyData === undefined || this.companyData === null) {
      this.getBusinnessInformation(process, index);
    } else {
      process.nameCompany = this.companyData.nombre;
      this.generatedExcel(process, index);
    }
  }

  generatedExcel(process: IAffiliatesProcess, index: number) {
    this.affiliationService.getExcelAffiliationMas(process).subscribe((res) => {
      const auxLink = document.createElement("a");
      document.body.appendChild(auxLink);
      const url = `data:application/vnd.ms-excel;base64,${res}`;
      auxLink.href = url;
      auxLink.target = "_blank";
      auxLink.hidden = true;
      auxLink.setAttribute("aria-label", "true");
      auxLink.download = `${process.processCode}.xls`;
      auxLink.click();
      window.URL.revokeObjectURL(url);
      this.loadingDetail[index] = false;
    });
  }

  getBusinnessInformation(process: IAffiliatesProcess, index: number) {
    this.companyService
      .getBusinnessInformation(
        InformationFormatting.returnNameDocumentCompany(
          this.userloggedin.docTypeCompany
        ),
        this.userloggedin.docNumberCompany,
        this.userloggedin.checkDigit
      )
      .pipe(
        map((response) => {
          if (
            response.body &&
            response.body.data[0].contribuyente &&
            response.body.data[0] &&
            response.body.data[0].contribuyente
          ) {
            this.companyData = response.body.data[0].contribuyente;
            this._STORAGE.stringifyItem(
              environment.LOCAL_STORAGE.BUSINESS_INFORMATION,
              this.companyData
            );
            process.nameCompany = this.companyData.nombre;
            this.generatedExcel(process, index);
          }
        }),
        catchError((err) => {
          return throwError(err);
        })
      )
      .subscribe();
  }

  showElement(process: IAffiliatesProcess, index: number) {
    this.loadingDetail[index] = true;
    this.affiliationService.getDetailAffiliation(process).subscribe((res) => {
      process.processAffiliationData = res;
      this._STORAGE.stringifyItem(environment.LOCAL_STORAGE.HISTORICO_AFILIACIONES_INFORMACION, process);
      let url = `/${RoutingPath.appRouting.components.affiliates_process.path}/`;
      url +=
        RoutingPath.appRouting.components.affiliates_process.pages.detail.path;
      this.loadingDetail[index] = false;
      this._ROUTER.navigate([url]);
    });
  }

  openLink() {
    this._ROUTER.navigate([
      RoutingPath.appRouting.components.affiliates_process.path,
    ]);
  }
}
